import { AuthService } from './../../core/auth.service';
import { Route } from './../../services/state/services-state';
import { Router } from '@angular/router';
import { ServicesStore } from './../../services/state/services-store';
import { PermissionsService } from './../../core/permissions.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { SidenavService } from '../../../app/core/sidenav.service';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-left-sidenav-menu',
  templateUrl: './left-sidenav-menu.component.html',
  styleUrls: ['./left-sidenav-menu.component.scss'],
})
export class LeftSidenavMenuComponent implements OnInit, OnDestroy {
  readonly reportsPermission = 'www_ds_reports';
  readonly archivePermission = 'server_archive_request';
  public userPermissions = {
    reports: true,
    archive: true,
    utils: true,
  };
  subscriber: Subscription;
  servicesStoreSubscription: Subscription;
  orientationChangedSubscription: Subscription;
  isLandscapeView: boolean = this.checkIfLandscape();
  isMenuExpanded = false;
  vehiclesRoute: Route = {
    url: '/vehicles',
  };
  mapRoute: Route = {
    url: '/map',
  };
  archivesRoute: Route = {
    url: '/archive',
  };
  reportRoute: Route = {
    url: '/reports',
  };
  deviceReportRoute: Route = {
    url: '/devices-reports',
  };
  servicesRoute: Route = {
    url: '/services/archive-downloader/vehicles-list',
  };
  constructor(
    public permissionsService: PermissionsService,
    public sidenavService: SidenavService,
    public servicesStore: ServicesStore,
    public router: Router,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.permissionsService.permissionsChange
      .pipe(filter((permissions) => !!permissions.length))
      .subscribe((permissions) => {
        this.userPermissions.reports =
          permissions.indexOf(this.reportsPermission) === -1;
        this.userPermissions.archive =
          permissions.indexOf(this.archivePermission) === -1;
      });
    this.userPermissions.utils =
      this.authService.getCookie('tempUser') == 'true';
    this.sidenavService.isSidenavOpened$.next(true);
    this.servicesStoreSubscription = this.servicesStore.state$.subscribe(
      (state) => {
        this.servicesRoute = { url: '/services' };
        if (state.lastRoute) {
          this.servicesRoute = {
            url:
              '/services' +
              (state.lastRoute.url ? '/' + state.lastRoute.url : ''),
            params: state.lastRoute.params || {},
          };
        }
      }
    );
    this.orientationChangedSubscription = fromEvent(
      window,
      'orientationchange'
    ).subscribe(() => {
      setTimeout(() => {
        this.isLandscapeView = this.checkIfLandscape();
      });
    });
  }

  ngOnDestroy(): void {
    if (this.servicesStoreSubscription)
      this.servicesStoreSubscription.unsubscribe();
    if (this.orientationChangedSubscription) {
      this.orientationChangedSubscription.unsubscribe();
    }
  }

  navigate(route: Route) {
    this.router.navigate([route.url], { queryParams: route.params });
  }

  isActive(route: Route): boolean {
    return this.router.isActive(route.url, false);
  }

  checkIfLandscape() {
    if (screen.orientation && screen.orientation.angle) {
      return screen.orientation.angle === 90;
    }

    return window.orientation === 90;
  }

  expandMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
  }
}
